export default function centimetersToMeters(n: number) {
  const conversion = n / 100;
  if (n % 100) {
    const c = conversion.toFixed(2);
    return c.replace('.', ',');
  } else {
    return conversion;
  }
}
